export const MessageTypes = Object.freeze({
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
});
